module.exports = __webpack_public_path__ + "static/NunitoSans-Bold-d0b6d0f05c00552a21519d6bdb3e5ed7.woff2";